import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const communityGardenBeneficiaryObject = z.object({
  id: z.string().uuid(),
  communityGardenId: z.string().uuid(),
  citizenId: z.string().uuid(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type CommunityGardenBeneficiaryType = z.infer<typeof communityGardenBeneficiaryObject>

export const propertyMap = {
  id: sql`community_garden_beneficiary.id`,
  communityGardenId: sql`community_garden_beneficiary.community_garden_id`,
  citizenId: sql`community_garden_beneficiary.citizen_id`,
  createdAt: sql`community_garden_beneficiary.created_at`,
  updatedAt: sql`community_garden_beneficiary.updated_at`,
  deletedAt: sql`community_garden_beneficiary.deleted_at`,
}

export default communityGardenBeneficiaryObject
